export default __webpack_public_path__ + "static/media/Kevin.fc7ba767.png";